import React, { memo, useMemo } from "react";
import { GridColDef, GridSortDirection } from "@mui/x-data-grid";
import ReportingTable from "./ReportingTable";

const DataTable = memo(function DataTable({
  columns,
  rows,
  loading,
  pages,
  reportedQuestions,
  filters,
  setFilters,
  onPageChange,
}: {
  columns: GridColDef[];
  rows: any[];
  loading: boolean;
  pages: number;
  reportedQuestions: any;
  filters: any;
  setFilters: (fn: any) => void;
  onPageChange: (page: number) => void;
}) {
  // memoize rows + columns so they don’t get new references on every render
  const memoRows = useMemo(() => rows, [rows]);
  const memoColumns = useMemo(() => columns, [columns]);

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <ReportingTable
        rows={memoRows}
        loading={loading}
        columns={memoColumns}
        pagination={{
          page: pages,
          count: reportedQuestions.count ?? 0,
          onPageChange: onPageChange,
          sort_by: filters.sort_by ?? "",
          sort_by_type: filters.sort_by_type ?? "",
          setSort_by: (val?: string, type?: GridSortDirection) => {
            if (type === undefined) {
              if (filters.sort_by) {
                setFilters((prev: any) => ({
                  ...prev,
                  sort_by_type: undefined,
                  sort_by: undefined,
                }));
              }
            } else if (
              filters.sort_by !== val ||
              filters.sort_by_type !== type
            ) {
              setFilters((prev: any) => ({
                ...prev,
                sort_by_type: type ? (type === "asc" ? "+" : "-") : "-",
                sort_by: val ?? "",
              }));
              onPageChange(1);
            }
          },
        }}
      />
    </div>
  );
});

export default DataTable;
